module.exports = __webpack_public_path__ + "static/media/rain-solution.8b674dbb.svg";